/**
 * /welcome — the Path-A login warm-up splash.
 *
 * A Tracker-home user lands here right after login (see lib/postLoginHome.ts).
 * The splash polls GET /api/tracking/portal/warmup/status until the portfolio
 * snapshots are fresh, then hands the user to /portal (or the ?redirect deep
 * link they were originally headed for). It is a best-effort background nicety:
 * an "Enter dashboard ->" escape is always available so a stalled warm-up
 * worker can never trap a login.
 *
 * The route is AUTHED but renders BARE — __root.tsx keeps the SidebarNav out
 * (see `isWelcomeRoute`) so <WelcomeWarmup> owns the full viewport, the same
 * way LoginFiling and PortalLayout own their own chrome.
 *
 * `validateSearch` mirrors ll97.tsx / the /login redirect contract: a single
 * optional `redirect` string carried through from the login URL.
 */
import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import WelcomeWarmup from "@/pages/Welcome/WelcomeWarmup";
import { safeRedirect } from "@/lib/postLoginHome";

const WelcomeRoute = () => <WelcomeWarmup />;

export const Route = createFileRoute("/welcome")({
  validateSearch: (s: Record<string, unknown>): { redirect?: string } => ({
    redirect: safeRedirect(s.redirect),
  }),
  component: WelcomeRoute,
});
